export { WasmModulesComponent } from './wasm-modules.component';
